module.exports = __webpack_public_path__ + "kp.svg?33d60e625bbf5f0d6849c59a294a363f";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/kp.svg
// module id = 1047
// module chunks = 27